import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, X } from 'lucide-react';
import api from '../../lib/api';

const formatDate = (iso) => {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long' });
  } catch {
    return iso;
  }
};

const InscriptionTopBanner = () => {
  const [info, setInfo] = useState(null);
  const [closed, setClosed] = useState(() => sessionStorage.getItem('inscription-banner-closed') === '1');

  useEffect(() => {
    api.get('/settings/site-info')
      .then((r) => setInfo(r.data))
      .catch(() => setInfo(null));
  }, []);

  if (!info || !info.inscription_open || closed) return null;

  const start = formatDate(info.inscription_period_start);
  const end = formatDate(info.inscription_period_end);
  const year = info.inscription_year || '';

  return (
    <div
      className="bg-gradient-to-r from-[#285BBB] via-[#2C3C65] to-[#285BBB] text-white text-sm relative"
      data-testid="inscription-top-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 pr-10">
        <Calendar className="h-4 w-4 flex-shrink-0" />
        <span className="font-medium">
          {start && end
            ? <>Inscriptions ouvertes du <strong>{start}</strong> au <strong>{end}</strong></>
            : <>Inscriptions ouvertes</>
          }
          {year && <> — <strong>Année {year}</strong></>}
        </span>
        <Link
          to="/inscription"
          className="inline-flex items-center bg-white text-[#285BBB] hover:bg-amber-50 hover:text-[#2C3C65] font-semibold px-4 py-1 rounded-full transition-colors"
          data-testid="inscription-banner-cta"
        >
          S'inscrire
          <ArrowRight className="h-4 w-4 ml-1.5" />
        </Link>
      </div>
      <button
        onClick={() => { setClosed(true); sessionStorage.setItem('inscription-banner-closed', '1'); }}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white"
        aria-label="Fermer"
        data-testid="inscription-banner-close"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default InscriptionTopBanner;
